import { render, staticRenderFns } from "./StylistCommentsModal.vue?vue&type=template&id=18155a56&scoped=true"
import script from "./StylistCommentsModal.vue?vue&type=script&lang=js"
export * from "./StylistCommentsModal.vue?vue&type=script&lang=js"
import style0 from "./StylistCommentsModal.vue?vue&type=style&index=0&id=18155a56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18155a56",
  null
  
)

export default component.exports